import { Component, EventEmitter, Output, Input } from '@angular/core';
import { MapStyle } from '@nx-fe/map';

@Component({
  selector: 'ssp-map-view-type-button',
  templateUrl: './map-view-type-button.component.html',
  styleUrls: ['./map-view-type-button.component.scss', '../../../../../../../../../assets/soti-tooltip.scss'],
})
export class MapViewTypeButtonComponent {
  satelliteView = MapStyle.SATELLITE;

  @Input()
  viewType: MapStyle;

  @Output()
  toggleViewType = new EventEmitter<null>();

  emitToggle() {
    this.toggleViewType.emit();
  }
}
